import { PropsWithChildren, ReactNode } from 'react';

interface Props extends PropsWithChildren {
  if: boolean;
  else?: ReactNode;
}

export const ConditionView: React.FC<Props> = ({ if: condition, else: otherwise = null, children }) => {
  return <>{condition ? children : otherwise}</>;
};
